var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.81934C7.5 4.05791 9.73858 1.81934 12.5 1.81934H15C15.4602 1.81934 15.8333 2.19243 15.8333 2.65267V5.986C15.8333 6.44624 15.4602 6.81934 15 6.81934H12.5V8.486H15C15.5421 8.486 15.9399 8.99549 15.8085 9.52145L14.9751 12.8548C14.8824 13.2258 14.5491 13.486 14.1667 13.486H12.5V19.3193C12.5 19.7796 12.1269 20.1527 11.6667 20.1527H8.33333C7.8731 20.1527 7.5 19.7796 7.5 19.3193V13.486H5.83333C5.3731 13.486 5 13.1129 5 12.6527V9.31933C5 8.8591 5.3731 8.486 5.83333 8.486H7.5V6.81934ZM14.1667 3.486H12.5C10.6591 3.486 9.16667 4.97839 9.16667 6.81934V9.31934C9.16667 9.77957 8.79357 10.1527 8.33333 10.1527H6.66667V11.8193H8.33333C8.79357 11.8193 9.16667 12.1924 9.16667 12.6527V18.486H10.8333V12.6527C10.8333 12.1924 11.2064 11.8193 11.6667 11.8193H13.516L13.9327 10.1527H11.6667C11.2064 10.1527 10.8333 9.77957 10.8333 9.31934V6.81934C10.8333 5.89886 11.5795 5.15267 12.5 5.15267H14.1667V3.486Z",
    fill: "#FAF1E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7321_20528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 11,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 6.81934C7.5 4.05791 9.73858 1.81934 12.5 1.81934H15C15.4602 1.81934 15.8333 2.19243 15.8333 2.65267V5.986C15.8333 6.44624 15.4602 6.81934 15 6.81934H12.5V8.486H15C15.5421 8.486 15.9399 8.99549 15.8085 9.52145L14.9751 12.8548C14.8824 13.2258 14.5491 13.486 14.1667 13.486H12.5V19.3193C12.5 19.7796 12.1269 20.1527 11.6667 20.1527H8.33333C7.8731 20.1527 7.5 19.7796 7.5 19.3193V13.486H5.83333C5.3731 13.486 5 13.1129 5 12.6527V9.31933C5 8.8591 5.3731 8.486 5.83333 8.486H7.5V6.81934ZM14.1667 3.486H12.5C10.6591 3.486 9.16667 4.97839 9.16667 6.81934V9.31934C9.16667 9.77957 8.79357 10.1527 8.33333 10.1527H6.66667V11.8193H8.33333C8.79357 11.8193 9.16667 12.1924 9.16667 12.6527V18.486H10.8333V12.6527C10.8333 12.1924 11.2064 11.8193 11.6667 11.8193H13.516L13.9327 10.1527H11.6667C11.2064 10.1527 10.8333 9.77957 10.8333 9.31934V6.81934C10.8333 5.89886 11.5795 5.15267 12.5 5.15267H14.1667V3.486Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7321_20528)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f3722d59414aefe83f65a83489b1c82b.svg";
export { ForwardRef as ReactComponent };